import React, { useState, useEffect, useContext } from "react";
import { Page, Card, Layout } from "@shopify/polaris";
import FieldsForm from "./Form";
import { Navigate } from "react-router-dom";
import { AppContext } from "../../../../components/global/appContext";
import useCompare from "../../../../hooks/useCompare";
import { TitleBar } from "@shopify/app-bridge-react";
import { useCreateField, useGetField } from "../../../../hooks/queries/fields";
import FieldSkeletonForm from "./SkeletonForm";
import { useTranslation } from "react-i18next";

export default function FieldsNew(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);

  const { data, isError } = useGetField("new");
  const [field, setField] = useState(data);
  useEffect(() => setField(data), [data]);

  const [fieldCreated, setFieldCreated] = useState(false);

  const createFieldMutation = useCreateField({
    onSuccess: () => {
      appContext.setMessage(t("settings.customFields.new.messages.savedSuccessfully"));
      setFieldCreated(true);
    },
    onError: () => appContext.setMessage(t("settings.customFields.new.messages.couldntSave"), true),
  });

  const hasUnsavedChanges = !useCompare(data, field);

  // Handle form submission (triggered by Save Bar)
  const handleSubmit = (e) => {
    e.preventDefault();
    createFieldMutation.mutate(field);
  };

  // Handle form reset (triggered by Discard button in Save Bar)
  const handleReset = (e) => {
    e.preventDefault();
    setField(data);
  };

  if (fieldCreated)
    return <Navigate to="/settings/fields" />;
  if (isError) return <p>{t("settings.customFields.error")}</p>;
  if (!field) return <FieldSkeletonForm />;

  return (
    <form 
      data-save-bar 
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
    <Page>
      <TitleBar
        title={t("settings.customFields.new.title")}
        breadcrumbs={[
          { content: t("settings.title") },
          { content: t("settings.customFields.title"), url: "/settings/fields" },
        ]}
      />
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <FieldsForm field={field} setField={setField} />
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
    </form>
  );
}
